import { useEffect, useState } from "react";
import { motion, animate } from "framer-motion";
import { Monitor, MessageCircle } from "lucide-react";

const BAR_INITIAL = { width: 0 };
const BAR_TRANSITION = { duration: 1.4, ease: "easeOut" };

function Counter({ value }) {
  const [v, setV] = useState(0);
  useEffect(() => {
    const c = animate(v, value, { duration: 1.2, ease: "easeOut", onUpdate: (x) => setV(Math.round(x)) });
    return () => c.stop();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);
  return <>{v}</>;
}

export default function ChannelRace({ channels, accent = "#f59e0b" }) {
  if (!channels || !channels.some((c) => c.plays > 0)) return null;
  const total = channels.reduce((a, c) => a + c.plays, 0) || 1;
  const colors = { totem: accent, whatsapp: "#25D366" };
  const icons = { totem: Monitor, whatsapp: MessageCircle };
  return (
    <div className="w-full max-w-[70vmin] rounded-[2vmin] bg-black/45 backdrop-blur-md border border-white/15 p-[2.5vmin] text-left mt-[2vmin]" data-testid="display-channel-race">
      <div className="flex items-center gap-[1vmin] mb-[1.5vmin]">
        <h2 className="font-display font-bold text-[2.8vmin] leading-none">Oggi: Totem vs WhatsApp</h2>
        <span className="ml-auto text-[1.8vmin] text-white/60">{total} giocate</span>
      </div>
      <div className="space-y-[1.2vmin]">
        {channels.map((c) => {
          const Icon = icons[c.key] || Monitor;
          const pct = Math.round((c.plays / total) * 100);
          return (
            <div key={c.key} className="relative overflow-hidden rounded-[1.2vmin] bg-white/10" data-testid={`channel-race-${c.key}`}>
              <motion.div className="absolute inset-y-0 left-0 rounded-[1.2vmin]" style={{ background: colors[c.key], opacity: 0.4 }} initial={BAR_INITIAL} animate={{ width: `${pct}%` }} transition={BAR_TRANSITION} />
              <div className="relative flex items-center gap-[1.5vmin] px-[1.5vmin] py-[1.2vmin]">
                <span className="grid place-items-center h-[3.4vmin] w-[3.4vmin] rounded-full" style={{ background: colors[c.key] }}>
                  <Icon className="h-[2vmin] w-[2vmin] text-slate-900" />
                </span>
                <span className="font-semibold text-[2.2vmin] flex-1">{c.label}</span>
                <span className="text-[1.8vmin] text-white/70">{c.wins} vincite</span>
                <span className="font-display font-black text-[2.8vmin] w-[9vmin] text-right"><Counter value={c.plays} /></span>
                <span className="text-[2vmin] text-white/80 w-[6vmin] text-right">{pct}%</span>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
